var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0107(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5h38",
    stroke: "#2A7ADB",
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "5,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0107);
export default __webpack_public_path__ + "static/media/icon-legend-01-07.71cdfed32f813403df5b17bba7f77f74.svg";
export { ForwardRef as ReactComponent };